import React, { useRef } from 'react';
import { Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import styles from '../../styles/formComponent/CheckboxComponent.module.scss';

const CheckboxComponent = ({
  label,
  name,
  checked = false,
  onChange,
  onBlur,
  onFocus,
  required = false,
  disabled = false,
  error,
  helperText,
  size = 'medium',
  indeterminate = false,
  description,
  tooltip,
  className = '',
  value,
  ...props
}) => {
  const checkboxRef = useRef(null);

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  const handleFocus = (e) => {
    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  const handleLabelClick = () => {
    if (!disabled && checkboxRef.current) {
      checkboxRef.current.click();
    }
  };

  const getWrapperClasses = () => {
    let classes = `${styles.checkboxWrapper}`;
    if (size === 'small') classes += ` ${styles.small}`;
    if (size === 'large') classes += ` ${styles.large}`;
    if (disabled) classes += ` ${styles.disabled}`;
    if (className) classes += ` ${className}`;
    return classes;
  };

  const getCustomCheckboxClasses = () => {
    let classes = styles.checkboxCustom;
    if (checked) classes += ` ${styles.checked}`;
    if (indeterminate) classes += ` ${styles.indeterminate}`;
    if (error) classes += ` ${styles.error}`;
    if (disabled) classes += ` ${styles.disabled}`;
    return classes;
  };

  const getLabelClasses = () => {
    let classes = styles.label;
    if (disabled) classes += ` ${styles.disabled}`;
    if (error) classes += ` ${styles.error}`;
    return classes;
  };

  const getDescriptionClasses = () => {
    let classes = styles.description;
    if (disabled) classes += ` ${styles.disabled}`;
    return classes;
  };

  return (
    <div className={getWrapperClasses()}>
      <div className={styles.checkboxContainer}>
        <input
          ref={checkboxRef}
          type="checkbox"
          name={name}
          checked={checked}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          required={required}
          className={styles.checkbox}
          value={value}
          {...props}
        />
        <div className={getCustomCheckboxClasses()} />
      </div>

      <div className={styles.contentColumn}>
        {(label || description) && (
          <div className={styles.labelContainer} onClick={handleLabelClick}>
            {label && (
              <label className={getLabelClasses()}>
                {label}
                {required && <span className={styles.requiredMark}> *</span>}
                {tooltip && (
                  <Tooltip title={tooltip} arrow placement="top">
                    <InfoOutlined
                      sx={{ width: 14, height: 14, ml: 0.5, verticalAlign: 'middle', color: 'text.secondary' }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Tooltip>
                )}
              </label>
            )}
            {description && (
              <div className={getDescriptionClasses()}>
                {description}
              </div>
            )}
          </div>
        )}

        {error && (
          <div className={styles.errorMessage}>{error}</div>
        )}
        {helperText && !error && (
          <div className={styles.helperText}>{helperText}</div>
        )}
      </div>
    </div>
  );
};

export default CheckboxComponent;